export type CardFace = 'front' | 'whats-included';

/**
 * Names a control for the face it is on.
 *
 * Both faces are mounted at once — the panel is hidden with `aria-hidden`, not unmounted, so it can
 * be measured — so an unqualified name would match two elements. Prefixing the panel's copy keeps
 * `[data-component="checkout-button"]` matching exactly one, as the e2e selectors expect.
 */
export const faceComponentName = (face: CardFace, name: string) => (face === 'front' ? name : `whats-included-${name}`);
